import { render } from "./InvoiceTabs.vue?vue&type=template&id=97766d5c"
import script from "./InvoiceTabs.vue?vue&type=script&lang=js"
export * from "./InvoiceTabs.vue?vue&type=script&lang=js"

import exportComponent from "/Users/souban/Documents/Code/Amaze-Portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__